import { render, staticRenderFns } from "./NewDiagnose.vue?vue&type=template&id=d6e2e0cc&scoped=true"
import script from "./NewDiagnose.vue?vue&type=script&lang=js"
export * from "./NewDiagnose.vue?vue&type=script&lang=js"
import style0 from "./NewDiagnose.vue?vue&type=style&index=0&id=d6e2e0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e2e0cc",
  null
  
)

export default component.exports